<template>
    <modal
      title=""
      width="35"
      :showModal="showModal"
      @close-modal="closeModal"
      >
      <!-- <div class="table__search-input-wrapper w-[350px] filter-search">
        <span class="pr-2 opacity-50"><search-icon /> </span>

        <input
          type="text"
          class="table__search-input"
          placeholder="Search..."
        />
      </div> -->
    <div class="individual-contaoner">
        <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Country(s)</span></label>
        <el-select filterable v-model="filter.country" placeholder="All">
          <el-option
            v-for="state in states"
            :key="state.id"
            :label="state.name"
            :value="state.name"
          >
          </el-option>
        </el-select>
      </div>

      <div class="individual-contaoner">
        <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Terminal(s)</span></label>
        <el-select filterable v-model="filter.terminal" placeholder="All">
          <el-option
            v-for="state in states"
            :key="state.id"
            :label="state.name"
            :value="state.name"
          >
          </el-option>
        </el-select>
      </div>

      <div class="individual-contaoner">
        <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Route(s)</span></label>
        <el-select filterable v-model="filter.route"  placeholder="All">
          <el-option
            v-for="route in routes"
            :key="route.id"
            :label="route.locationName"
            :value="route.id"
          >
          </el-option>
        </el-select>
      </div>

      <div class="individual-contaoner">
        <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Fleet(s)</span></label>
        <el-select filterable v-model="filter.fleet" placeholder="All">
          <el-option
            v-for="fleet in fleets"
            :key="fleet.id"
            :label="fleet.equipment"
            :value="fleet.equipment"
          >
          </el-option>
        </el-select>
      </div>
  
      <div class="flex items-center cursor-pointer mt-5">
        <div>
            <primary-button
              buttonText="Apply"
              :loading="loading"
            />
          </div>
        <div>
          <p class="pl-3">Cancel</p>
        </div>
       
      </div>
    </modal>
  </template>
  
  <script>
  export default {
    props: {
      showModal: {
        type: Boolean,
        required: true,
      },
    },

    data() {
      return {
        loading: false,
        fleets: [],
        routes: [],
        filter: {
            route: "",
            fleet: "",
            terminal: "",
            country: ""
        },
  
      };
    },
    mounted() {
        this.getFleets();
        this.getAllRoutes()
    },
    methods: {
      closeModal() {
        this.$emit("close-modal");
      },
      async getFleets() {
      try {
        let response = await this.$_getAllFleets();
        this.fleets = response.data.data.fleet;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllRoutes() {
      try {
        let response = await this.$_getAll3plLocations();

        this.routes = response.data.data.locations;
      } catch (error) {
        this.handleError(error);
      }
    },
    },
  };
  </script>
  
  <style scoped lang="scss">
   .label{
    @apply border-b-2 border-gray-400 w-full pb-1;
    font-size: 13px;
   }
   .individual-contaoner{
    @apply w-full border-2 border-gray-300 border-dashed p-2 my-3
   }
   .filter-search{
    border-radius: 4px;
    @apply py-2
   }
</style>
  